module.exports = __webpack_public_path__ + "img/25.464c3298.jpg";